import { render } from "./VMore.vue?vue&type=template&id=36914d5c&scoped=true"
import script from "./VMore.vue?vue&type=script&lang=js"
export * from "./VMore.vue?vue&type=script&lang=js"

import "./VMore.vue?vue&type=style&index=0&id=36914d5c&scoped=true&lang=scss"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36914d5c"]])

export default __exports__